import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {sendOTP, validateProcess} from "../../../store/verification.slice";
import PhoneNumberInput from "./PhoneNumberInput";
import Loading from "../../reusable/Loading";
import CodeValidator from "../../reusable/CodeValidator";
import {useSelector} from "react-redux";
import {trackEvent} from "../../../utils/analytics";


function PhoneCheck({inputChange, verification}) {
    const { t } = useTranslation();
    const [codeSent, setCodeSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [phoneInput, setPhoneInput] = useState("");
    const [validationErr, setValidationErr] = useState("");
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const {credentials} = useSelector((store) => store.verification);


    const sendOtp = () => {
        setLoading(true)
        setError("")
        setValidationErr("")
        setCodeSent(false)
        sendOTP(phoneInput, params.get('clientId'), params.get('flowId'), verification?.verificationId,
            credentials?.accessToken, "PHONE").then(({sent}) => {
            if (!sent) {
                skipCodeEntry()
                return
            }
            trackEvent("phone_otp_sent", {flowId: verification?.flowId, verificationId: verification?.verificationId})
            setLoading(false)
            setCodeSent(true)
        }).catch(err => {
            console.error("sendOTP failed", err)
            trackEvent("phone_otp_send_failed", {flowId: verification?.flowId, verificationId: verification?.verificationId, error: err + ""})
            setCodeSent(false)
            setLoading(false)
            setError(t("phoneCheck.sendError"))
        })
    }

    // No code was sent (the organisation's wallet couldn't pay for the SMS), so there's nothing to
    // enter - submit the number unconfirmed and let the verification go to review.
    const skipCodeEntry = () => {
        trackEvent("phone_otp_skipped", {flowId: verification?.flowId, verificationId: verification?.verificationId})
        setLoading(false)
        inputChange([{
            document: null,
            field: {
                fieldName: "PHONE_NUMBER",
                value: phoneInput
            }
        }])
    }

    const validateNumber = (code) => {
        setLoading(true)
        validateProcess("PHONE_CHECK",
            [], [
                {fieldName: "PHONE_NUMBER", value: phoneInput},
                {fieldName: "OTP_CODE", value: code}
            ], params.get('clientId'), verification?.verificationId,
            credentials?.accessToken).then(() => {
            trackEvent("phone_otp_verified", {flowId: verification?.flowId, verificationId: verification?.verificationId})
            setLoading(false)
            inputChange(
                [{
                    document: null,
                    field: {
                        fieldName: "PHONE_NUMBER",
                        value: phoneInput
                    }
                },
                    {
                        document: null,
                        field: {
                            fieldName: "OTP_CODE",
                            value: code
                        }
                    }
                ])
        }).catch(err => {
            setLoading(false)
            let validationErr;
            if (err.response && err.response.data) {
                const errors = err.response.data;
                // Assuming errors is an array of error objects
                validationErr = errors.map(error => error?.defaultMessage).join('\n');
            } else {
                // Handle unexpected error format
                validationErr = t("phoneCheck.unexpectedError");
            }
            trackEvent("phone_otp_verify_failed", {flowId: verification?.flowId, verificationId: verification?.verificationId, error: validationErr})
            setValidationErr(validationErr);
        })
    }

    const resendOtp = () => {
        setError("")
        setValidationErr("")
        trackEvent("phone_otp_resent", {flowId: verification?.flowId, verificationId: verification?.verificationId})
        sendOTP(phoneInput, params.get('clientId'), params.get('flowId'), verification?.verificationId,
            credentials?.accessToken, "PHONE").then(({sent}) => {
            if (!sent) {
                skipCodeEntry()
            }
        }).catch(err => {
            console.error("resendOTP failed", err)
            setError("Failed to resend code. Please try again.")
        })
    }

    const goback = () => {
        setCodeSent(false)
        setLoading(false)
    }

    return (
        <div className="h-full w-full">
            {((!codeSent && !loading) || (error)) &&
                <PhoneNumberInput sendOtp={sendOtp} error={error} setPhoneInput={setPhoneInput}/>}
            {codeSent && <CodeValidator sendCode={resendOtp} title={t("phoneCheck.verifyTitle")} target={phoneInput}
                                        validationErr={validationErr} goback={goback}
                                        validate={validateNumber}/>}
            {loading && <Loading/>}
        </div>
    );
}

export default PhoneCheck;
